(() => {
  const COLLECTION_PRODUCTS_RETURN_KEY = 'kurlective:return-to-collection-products';

  const scrollToCollectionProducts = () => {
    const target = document.getElementById('collection-products');
    if (!target) return;

    const settleAndScroll = () => {
      window.setTimeout(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            target.scrollIntoView({ block: 'start', behavior: 'smooth' });
          });
        });
      }, 120);
    };

    if (document.fonts?.ready) {
      document.fonts.ready.then(settleAndScroll).catch(settleAndScroll);
    } else {
      settleAndScroll();
    }
  };

  const currentUrl = new URL(window.location.href);
  const previewTheme = currentUrl.searchParams.get('preview_theme_id');

  document.querySelectorAll('[data-k-collection-jump]').forEach((link) => {
    const raw = link.getAttribute('href');
    if (!raw) return;

    try {
      const url = new URL(raw, window.location.origin);
      if (url.origin !== window.location.origin) return;

      url.hash = '';
      if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
      link.href = url.pathname + url.search;

      link.addEventListener('click', (event) => {
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) return;

        const destination = new URL(link.href, window.location.origin);
        const sameDestination =
          destination.pathname === currentUrl.pathname &&
          destination.search === currentUrl.search;

        if (sameDestination) {
          event.preventDefault();
          scrollToCollectionProducts();
          return;
        }

        sessionStorage.setItem(COLLECTION_PRODUCTS_RETURN_KEY, '1');
      });
    } catch (_) {}
  });

  if (sessionStorage.getItem(COLLECTION_PRODUCTS_RETURN_KEY) === '1') {
    sessionStorage.removeItem(COLLECTION_PRODUCTS_RETURN_KEY);
    if (document.readyState === 'complete') {
      scrollToCollectionProducts();
    } else {
      window.addEventListener('load', scrollToCollectionProducts, { once: true });
    }
  }

  const roots = document.querySelectorAll('[data-k-collection-profile]');
  roots.forEach((root) => {
    if (root.dataset.collectionProfileReady === 'true') return;
    root.dataset.collectionProfileReady = 'true';

    const current = new URL(window.location.href);
    const previewTheme = current.searchParams.get('preview_theme_id');
    if (previewTheme) {
      root.querySelectorAll('a[href]').forEach((link) => {
        const raw = link.getAttribute('href');
        if (!raw || raw.startsWith('#') || raw.startsWith('mailto:') || raw.startsWith('tel:')) return;
        try {
          const url = new URL(raw, window.location.origin);
          if (url.origin !== window.location.origin) return;
          url.searchParams.set('preview_theme_id', previewTheme);
          link.href = `${url.pathname}${url.search}${url.hash}`;
        } catch (_) {}
      });
    }

    root.querySelectorAll('[data-collection-stores]').forEach((section) => {
      const preview = section.querySelector('[data-collection-store-preview]');
      const image = section.querySelector('[data-collection-store-preview-image]');
      const placeholder = section.querySelector('[data-collection-store-preview-placeholder]');
      const name = section.querySelector('[data-collection-store-preview-name]');
      const description = section.querySelector('[data-collection-store-preview-description]');
      const count = section.querySelector('[data-collection-store-preview-count]');
      const rows = [...section.querySelectorAll('[data-collection-store-row]')];
      if (!preview || !rows.length) return;

      let activeImageRequest = 0;
      const showPlaceholder = (row) => {
        if (image) { image.hidden = true; image.style.setProperty('display', 'none', 'important'); }
        if (placeholder) { placeholder.textContent = row.dataset.storeInitials || 'STORE'; placeholder.hidden = false; placeholder.style.removeProperty('display'); }
      };
      const showImage = () => {
        if (image) { image.hidden = false; image.style.removeProperty('display'); }
        if (placeholder) { placeholder.hidden = true; placeholder.style.setProperty('display', 'none', 'important'); }
      };
      const activate = (row) => {
        rows.forEach((candidate) => candidate.classList.toggle('active', candidate === row));
        const src = row.dataset.storeImage || '';
        preview.href = row.href;
        if (name) name.textContent = row.dataset.storeName || '';
        if (description) description.textContent = row.dataset.storeDescription || '';
        if (count) count.textContent = `${row.dataset.storeCount || 0} products`;
        const requestId = ++activeImageRequest;
        if (src && image) {
          showPlaceholder(row);
          image.alt = row.dataset.storeName || '';
          image.onload = () => { if (requestId === activeImageRequest) showImage(); };
          image.onerror = () => { if (requestId === activeImageRequest) showPlaceholder(row); };
          image.src = src;
          if (image.complete && image.naturalWidth > 0) showImage();
        } else {
          if (image) image.removeAttribute('src');
          showPlaceholder(row);
        }
      };
      rows.forEach((row) => {
        row.addEventListener('mouseenter', () => activate(row));
        row.addEventListener('focus', () => activate(row));
      });
      activate(rows[0]);
    });
  });
})();
